(function () {

    angular
        .module('smartertoolsApp')
        .filter('dashedCurrency', dashedCurrency);

    function dashedCurrency() {
        return function (number, precision) {
            if (!number || isNaN(parseFloat(number)) || !isFinite(number))
                return '-';
            precision = precision || 2;
            if (number < 0) {
                return '-$' + numberWithCommas((number * -1).toFixed(precision));
            } else {
                return '$' + numberWithCommas(number.toFixed(precision));
            }
        }
    }

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

})();